// Hebrew → English dictionary for fixed UI strings.
// Exact (trimmed) matches are translated; REGEX_RULES handle dynamic strings.

export const DICT = {
  // ===== Navbar =====
  'דף הבית': 'Home',
  'ראשי': 'Main',
  'מידע': 'Info',
  'דירוג': 'Rankings',
  'דירוג שחקנים': 'Player Rankings',
  'הודעות': 'Messages',
  'תחרויות': 'Tournaments',
  'תחרויות יומיות': 'Daily Tournaments',
  'תחרויות נוקאאוט': 'Knockout Tournaments',
  'הסבר על הרמות': 'Levels Guide',
  'שיטת הניקוד': 'Points System',
  'חיפוש פרטנרים למשחק': 'Find a Playing Partner',
  'חיפוש מאמנים': 'Find Coaches',
  'מחנות אימונים לחו״ל': 'Training Camps Abroad',
  'לקהילה בווצאפ': 'WhatsApp Community',
  'יצירת קשר': 'Contact Us',
  'קהילה': 'Community',
  'ניהול': 'Admin',
  'אדמין': 'Admin',
  'ניהול האתר': 'Site Admin',
  'צור תחרות חדשה': 'Create New Tournament',
  'בחר סוג תחרות': 'Choose tournament type',
  'התנתק': 'Log out',
  'התחבר': 'Log in',
  'הרשמה': 'Sign up',
  'התחבר / הירשם': 'Login / Sign up',
  'הפרופיל שלי': 'My Profile',
  'פרופיל': 'Profile',
  'צפה בפרופיל ←': 'View profile ←',
  'החלף ערכת נושא': 'Toggle theme',
  'רענן את האתר': 'Refresh site',
  'תפריט ניווט': 'Navigation menu',
  'עברית': 'Hebrew',

  // ===== Common actions =====
  'שמור': 'Save',
  'שמירה': 'Save',
  'ביטול': 'Cancel',
  'אישור': 'Confirm',
  'סגור': 'Close',
  'מחק': 'Delete',
  'מחיקה': 'Delete',
  'מחק הכל': 'Delete all',
  'ערוך': 'Edit',
  'עריכה': 'Edit',
  'הוסף': 'Add',
  'שלח': 'Send',
  'חזרה': 'Back',
  'חזור': 'Back',
  'המשך': 'Continue',
  'טוען...': 'Loading...',
  'חיפוש': 'Search',
  'חפש': 'Search',
  'הכל': 'All',
  'כן': 'Yes',
  'לא': 'No',
  'פעולות': 'Actions',
  'פרטים': 'Details',
  'עוד': 'More',
  'חדש': 'New',
  'שגיאה': 'Error',
  'הצלחה': 'Success',

  // ===== HomePage =====
  'הקהילה המובילה לשחקני טניס בישראל': 'The leading community for tennis players in Israel',
  'קהילת הטניס הגדולה בישראל': "Israel's largest tennis community",
  'ראה תחרויות': 'View Tournaments',
  'מה הרמה שלי?': "What's my level?",
  'בדוק את רמת המשחק שלך': 'Check your playing level',
  'שחקנים פעילים': 'Active players',
  'מאמנים': 'Coaches',
  'תחרויות פעילות וקרובות': 'Active & Upcoming Tournaments',
  'הצטרפו לתחרויות הטניס המרגשות ביותר בישראל': 'Join the most exciting tennis tournaments in Israel',
  'טוען תחרויות...': 'Loading tournaments...',
  'אין תחרויות פעילות כרגע': 'No active tournaments right now',
  'צפה בכל התחרויות': 'View all tournaments',
  'צפה בכל התחרויות הפעילות': 'View all active tournaments',
  'צפה בפרטים': 'View details',
  'פרטים והרשמה': 'Details & Registration',
  'הירשם עכשיו': 'Register now',
  'הירשם עכשיו 🎾': 'Register now 🎾',
  'הסר אותי': 'Remove me',
  'פתוח להרשמה': 'Open for registration',
  'מלא': 'Full',
  'הסתיים': 'Finished',
  'יפתח בקרוב': 'Opening soon',
  'LIVE עכשיו': 'LIVE now',
  'משתתפים': 'Participants',
  'משתתפים:': 'Participants:',
  'זוגות': 'Doubles',
  'רשימת המתנה': 'Waiting list',
  '⏳ רשימת המתנה': '⏳ Waiting list',
  'למה לבחור בנו?': 'Why choose us?',
  'שדרגו את המשחק': 'Level up your game',
  'קהילת הטניס': 'Tennis Community',
  'הצטרף לקהילה': 'Join the community',
  'הצטרף לקבוצה': 'Join the group',
  'בוואטסאפ': 'on WhatsApp',
  'פורום טניס': 'Tennis Forum',
  'שיחות, טיפים ושאלות כלליות': 'Chats, tips and general questions',
  'ציוד טניס': 'Tennis Gear',
  'קנייה ומכירה - חדש ויד שנייה': 'Buy & sell — new and used',
  'תיאום משחקים': 'Match Scheduling',
  'מצא שותפים לאימון לפי רמות': 'Find training partners by level',
  'תחרויות ועדכונים': 'Tournaments & Updates',
  'עדכונים שוטפים על תחרויות': 'Ongoing tournament updates',
  'אימונים יומיים, מתקנים ברמה בינלאומית': 'Daily training, world-class facilities',
  'מאמנים מקומיים מקצועיים + מאמן ישראלי מלווה': 'Professional local coaches + accompanying Israeli coach',
  'שילוב מושלם של אימון, חברה ותיירות': 'A perfect mix of training, friends and travel',
  '3 יעדים · חוויה ייחודית': '3 destinations · a unique experience',
  'כל הזכויות שמורות.': 'All rights reserved.',

  // ===== Rankings =====
  'טבלת האלופים': 'Champions Table',
  'הטובים ביותר בטניס הישראלי 🎾': 'The best of Israeli tennis 🎾',
  'מובילי הדירוג': 'Top Ranked',
  'אלוף': 'Champion',
  'סגן אלוף': 'Runner-up',
  'מקום 3': '3rd place',
  'שחקן': 'Player',
  'רמה': 'Level',
  'ניקוד': 'Points',
  'נקודות': 'Points',
  'ניצחונות': 'Wins',
  'דרג א': 'Level A',
  'דרג ב': 'Level B',
  'דרג ג': 'Level C',
  'נשים': 'Women',
  'יחידים Open': 'Singles Open',
  'זוגות Open': 'Doubles Open',
  'יחידים open': 'Singles Open',
  'זוגות open': 'Doubles Open',
  'חפש שחקן...': 'Search player...',
  'טוען דירוג שחקנים...': 'Loading rankings...',
  'אין שחקנים בדירוג': 'No players ranked yet',
  'נסה לחפש קטגוריה אחרת': 'Try a different category',
  'מחובר עכשיו': 'Online now',
  'שגיאה במחיקת משתמש': 'Error deleting user',

  // ===== Messages / Chat =====
  "צ'אטים": 'Chats',
  'עדכונים': 'Updates',
  'סמן הכל כנקרא': 'Mark all as read',
  'אין שיחות עדיין': 'No conversations yet',
  'לחץ על שחקן מחובר למעלה כדי להתחיל שיחה 🎾': 'Tap an online player above to start a chat 🎾',
  'אין עדכוני מערכת': 'No system updates',
  'מאת:': 'From:',
  'מערכת Tennis Pro Israel': 'Tennis Pro Israel System',
  'מערכת': 'System',
  'טוען הודעות...': 'Loading messages...',
  'שגיאה בטעינת הודעות': 'Error loading messages',
  'ההודעה נמחקה בהצלחה': 'Message deleted',
  'שגיאה במחיקת ההודעה': 'Error deleting message',
  'שגיאה במחיקת ההודעות': 'Error deleting messages',
  'שגיאה בסימון ההודעות': 'Error marking messages',
  'כל העדכונים נמחקו 🗑️': 'All updates deleted 🗑️',
  'כל העדכונים סומנו כנקראו ✓': 'All updates marked as read ✓',
  'האם אתה בטוח שברצונך למחוק הודעה זו?': 'Are you sure you want to delete this message?',
  'למחוק את כל העדכונים? פעולה זו לא ניתנת לביטול': 'Delete all updates? This cannot be undone',
  '📢 הודעת מערכת': '📢 System message',
  '🤖 הודעה אוטומטית': '🤖 Automatic message',
  'שיחה פרטית · מתעדכן אוטומטית': 'Private chat · updates automatically',
  'מחובר עכשיו · שיחה פרטית': 'Online now · private chat',
  'מחובר': 'Online',
  'כתוב הודעה...': 'Type a message...',
  'אין הודעות עדיין — תתחילו לדבר 🎾': 'No messages yet — start talking 🎾',
  'הקלט הודעה קולית': 'Record a voice message',
  'עצור ושלח': 'Stop & send',
  'שלח תמונה': 'Send image',
  'שגיאה בשליחת ההודעה': 'Error sending message',
  'שגיאה בשליחת ההקלטה': 'Error sending recording',
  'שגיאה בשליחת התמונה': 'Error sending image',
  'התמונה גדולה מדי': 'Image is too large',
  'יש לבחור קובץ תמונה': 'Please choose an image file',
  'אין גישה למיקרופון - אשר הרשאה בדפדפן': 'No microphone access — allow it in your browser',
  "(מקס' 1:00)": '(max 1:00)',
  '🎤 הודעה קולית': '🎤 Voice message',
  '📷 תמונה': '📷 Image',
  'אתה:': 'You:',
  'מחוברים עכשיו': 'Online now',
  "הצ'אטים שלי": 'My Chats',
  'כל ההודעות': 'All messages',

  // ===== Notifications / Push =====
  'התראות': 'Notifications',
  'אין התראות חדשות': 'No new notifications',
  'הפעל התראות פוש 🔔': 'Enable push notifications 🔔',
  'קבל עדכונים על תחרויות והודעות גם כשהאתר סגור': 'Get tournament & message updates even when the site is closed',
  'לחץ לצפייה בשיחות': 'Tap to view chats',
  'התראות פוש הופעלו! תקבל עדכונים גם כשהאתר סגור 🔔': 'Push enabled! You will get updates even when the site is closed 🔔',
  'לא ניתן להפעיל התראות במכשיר זה': 'Cannot enable notifications on this device',
  'ההרשאה נדחתה. ניתן לאפשר בהגדרות הדפדפן.': 'Permission denied. You can allow it in browser settings.',
  'ההרשאה נדחתה - ניתן להפעיל דרך הגדרות הדפדפן': 'Permission denied — enable it in browser settings',

  // ===== Install prompt =====
  'אל תפספסו אף משחק! 🎾': "Don't miss a single match! 🎾",
  'שדרגו את החוויה שלכם באתר': 'Upgrade your site experience',
  'הפעלת התראות': 'Enable notifications',
  'התראות פעילות ✓': 'Notifications on ✓',
  'עדכונים על תחרויות, תוצאות והודעות': 'Updates on tournaments, results and messages',
  'שמירה למסך הבית': 'Add to Home Screen',
  'גישה מהירה כמו אפליקציה, בלי חנות': 'Fast app-like access, no store needed',
  'התראות הופעלו בהצלחה! 🔔': 'Notifications enabled! 🔔',
  'כדי לקבל התראות יש להתחבר קודם 🎾': 'Log in first to receive notifications 🎾',
  'שיתוף': 'Share',
  '"הוסף למסך הבית"': '"Add to Home Screen"',
  '"הוספה למסך הבית"': '"Add to Home Screen"',
  '"התקנת אפליקציה"': '"Install app"',
  'בסרגל הדפדפן ← ואז': 'in the browser bar ← then',
  '← ובחרו': '← and choose',

  // ===== Widgets =====
  '📅 התחרות הבאה שלך': '📅 Your next tournament',
  'ספירה לאחור': 'Countdown',
  'סטורי תוצאות': 'Results Stories',
  'התחרויות האחרונות שהסתיימו': 'Recently finished tournaments',
  'אלוף התחרות': 'Tournament Champion',
  'האלופים האחרונים שהרימו את הגביע 🏆': 'The latest champions to lift the trophy 🏆',
  'שתף הישג': 'Share achievement',
  'התמונה שותפה!': 'Image shared!',
  'שגיאה בשיתוף': 'Error sharing',
  'התמונה הורדה - שתף אותה בוואטסאפ/אינסטגרם 🎾': 'Image downloaded — share it on WhatsApp/Instagram 🎾',
  'צור קשר בוואטסאפ': 'Contact us on WhatsApp',

  // ===== Profile completion =====
  'השלמת פרופיל — חובה': 'Complete your profile — required',
  'כל השדות עם * הם חובה.': 'All fields marked * are required.',
  'ללא מילוי לא תוכל להמשיך לגלוש באתר.': 'You cannot continue browsing without filling them in.',
  'שם מלא': 'Full name',
  'שם פרטי ושם משפחה': 'First and last name',
  'שם מלא חובה': 'Full name is required',
  'אימייל': 'Email',
  'האימייל מקושר לחשבון ולא ניתן לשינוי': 'Email is linked to your account and cannot be changed',
  'מספר טלפון': 'Phone number',
  'מספר טלפון חובה': 'Phone number is required',
  'מספר טלפון לא תקין': 'Invalid phone number',
  'עיר מגורים': 'City',
  'עיר מגורים חובה': 'City is required',
  'לדוגמה: רעננה': 'e.g. Raanana',
  'רמת משחק / קטגוריה': 'Playing level / category',
  'רמת משחק חובה': 'Playing level is required',
  'בחר רמה': 'Choose level',
  'דרג א (מתקדמים)': 'Level A (advanced)',
  'דרג ב (בינוני)': 'Level B (intermediate)',
  'דרג ג (מתחילים)': 'Level C (beginners)',
  'הפרופיל עודכן! מעבר לאתר 🎾': 'Profile updated! Entering the site 🎾',
  'שגיאה בעדכון פרופיל': 'Error updating profile',

  // ===== Dates =====
  'תאריך': 'Date',
  'שעה': 'Time',
  'מיקום': 'Location',
  'כל הארץ': 'Nationwide',
  'היום': 'Today',
  'מחר': 'Tomorrow',
  'אתמול': 'Yesterday',
};

// Pattern rules for dynamic strings. Order matters.
export const REGEX_RULES = [
  [/^נראה לאחרונה לפני (\d+) דקות$/, 'Last seen $1 minutes ago'],
  [/^נראה לאחרונה לפני שעה$/, 'Last seen an hour ago'],
  [/^נראה לאחרונה לפני (\d+) שעות$/, 'Last seen $1 hours ago'],
  [/^נראה לאחרונה אתמול ב-(.+)$/, 'Last seen yesterday at $1'],
  [/^נראה לאחרונה ב-(.+)$/, 'Last seen on $1'],
  [/^יש לך (\d+) הודעות חדשות בצ'אט$/, 'You have $1 new chat messages'],
  [/^מחוברים עכשיו \((\d+)\)$/, 'Online now ($1)'],
  [/^(\d+) תחרויות$/, '$1 tournaments'],
  [/^(\d+) ממתינים$/, '$1 waiting'],
  [/^(\d+) נק'$/, '$1 pts'],
  [/^(\d+) נקודות$/, '$1 points'],
  [/^(\d+) ניצחונות ברצף$/, '$1 wins in a row'],
  [/^אתה: (.*)$/, 'You: $1'],
  [/^שלח הודעה ל(.+)$/, 'Message $1'],
  [/^לפני (\d+) דקות$/, '$1 minutes ago'],
  [/^לפני (\d+) שעות$/, '$1 hours ago'],
  [/^לפני (\d+) ימים$/, '$1 days ago'],
];

// Hebrew weekday & month tokens (translated inside strings that contain digits — i.e. dates)
export const DATE_TOKENS = [
  ['יום ראשון', 'Sunday'], ['יום שני', 'Monday'], ['יום שלישי', 'Tuesday'],
  ['יום רביעי', 'Wednesday'], ['יום חמישי', 'Thursday'], ['יום שישי', 'Friday'],
  ['שבת', 'Saturday'],
  ['בינואר', 'January'], ['בפברואר', 'February'], ['במרץ', 'March'], ['באפריל', 'April'],
  ['במאי', 'May'], ['ביוני', 'June'], ['ביולי', 'July'], ['באוגוסט', 'August'],
  ['בספטמבר', 'September'], ['באוקטובר', 'October'], ['בנובמבר', 'November'], ['בדצמבר', 'December'],
  ['ינואר', 'January'], ['פברואר', 'February'], ['מרץ', 'March'], ['אפריל', 'April'],
  ['מאי', 'May'], ['יוני', 'June'], ['יולי', 'July'], ['אוגוסט', 'August'],
  ['ספטמבר', 'September'], ['אוקטובר', 'October'], ['נובמבר', 'November'], ['דצמבר', 'December'],
  ["יום א'", 'Sun'], ["יום ב'", 'Mon'], ["יום ג'", 'Tue'], ["יום ד'", 'Wed'],
  ["יום ה'", 'Thu'], ["יום ו'", 'Fri'],
];

// ===== Tournaments pages =====
Object.assign(DICT, {
  'החלף עיצוב עמוד': 'Switch page design',
  'חפש תחרות...': 'Search tournament...',
  '🔍 חפש תחרות...': '🔍 Search tournament...',
  'טוען תחרויות יומיות...': 'Loading daily tournaments...',
  'טוען תחרויות נוקאאוט...': 'Loading knockout tournaments...',
  'נסה קטגוריה אחרת או חזור לבדוק בקרוב': 'Try another category or check back soon',
  'עליך להיות מחובר כדי להירשם': 'You must be logged in to register',
  'שגיאה בהרשמה': 'Registration error',
  'שגיאה בביטול': 'Cancellation error',
  'התחרות החלה — ההרשמה סגורה': 'Tournament started — registration closed',
  'התחרות החלה - ההרשמה סגורה': 'Tournament started — registration closed',
  '📋 ניתן עדיין להירשם לרשימת ההמתנה!': '📋 You can still join the waiting list!',
  'אין טורנירים בחודש זה': 'No tournaments this month',
  'אין תחרויות בקטגוריה זו': 'No tournaments in this category',
  'רשימת המתנה:': 'Waiting list:',
  '✅ הסתיים': '✅ Finished',
  '✨ פתוח להרשמה': '✨ Open for registration',
  '🔒 יפתח בקרוב': '🔒 Opening soon',
  '🔒 מלא': '🔒 Full',
  '🔴 LIVE - בתהליך': '🔴 LIVE - in progress',
  'תחרויות יומיות · עד 16 שחקנים': 'Daily tournaments · up to 16 players',
  'יום אחד · עד 16 שחקנים · אקשן מלא': 'One day · up to 16 players · full action',
  '🎾 נכנסים בבוקר, יוצאים עם גביע — תחרויות שמתחילות ומסתיימות באותו היום': '🎾 Arrive in the morning, leave with a trophy — tournaments that start and end the same day',

  // Tournament details
  'טוען פרטי תחרות...': 'Loading tournament details...',
  'התחרות לא נמצאה': 'Tournament not found',
  'שגיאה בטעינת פרטי התחרות': 'Error loading tournament details',
  'שם התחרות': 'Tournament name',
  'תיאור התחרות': 'Tournament description',
  'סוג תחרות': 'Tournament type',
  'קטגוריה': 'Category',
  'שעת התחלה': 'Start time',
  'מספר שחקנים מקסימלי': 'Max players',
  'קישור וואטסאפ': 'WhatsApp link',
  '✅ רשומים לתחרות': '✅ Registered players',
  'רשימת ההמתנה': 'Waiting list',
  'מה זה רשימת המתנה?': 'What is a waiting list?',
  '🏆 פרסים': '🏆 Prizes',
  '🎁 הפרס': '🎁 Prize',
  'מקום ראשון': '1st place',
  'מקום שני': '2nd place',
  'מקום שלישי': '3rd place',
  '🥇 מקום ראשון': '🥇 1st place',
  '🥈 מקום שני': '🥈 2nd place',
  '🥉 מקום שלישי': '🥉 3rd place',
  'מקום 1': '1st place',
  'מקום 2': '2nd place',
  'תנחומים:': 'Consolation:',
  'מקום 1 תנחומים': 'Consolation winner',
  '🏅 טורניר תנחומים': '🏅 Consolation bracket',
  'גלריית תמונות': 'Photo gallery',
  'אין תמונות בגלריה עדיין': 'No photos in the gallery yet',
  'התמונה נוספה לגלריה!': 'Photo added to the gallery!',
  'התמונה נמחקה': 'Photo deleted',
  'מחק תמונה': 'Delete photo',
  'האם למחוק את התמונה?': 'Delete this photo?',
  'שגיאה בהעלאת התמונה': 'Error uploading photo',
  'שגיאה במחיקת התמונה': 'Error deleting photo',
  'הקובץ גדול מדי. מקסימום 10MB': 'File too large. Max 10MB',
  'יש להעלות קובץ תמונה בלבד': 'Only image files can be uploaded',
  'זה אתה!': "That's you!",
  'זוג שלך!': 'Your pair!',
  'הבא בתור!': 'Next in line!',
  'הגיע': 'Arrived',
  'הגיע ✓': 'Arrived ✓',
  'לא הגיע': 'Not arrived',
  'שילם': 'Paid',
  'שילם ✓': 'Paid ✓',
  'לא שילם': 'Not paid',
  'שחקן חיצוני': 'External player',
  'נרשמת בהצלחה! התחרות מלאה - ההגרלה בוצעה! 🎉': 'Registered! Tournament is full — the draw was made! 🎉',
  'נרשמת לרשימת ההמתנה! 📋 תקבל הודעה כשתפנה מקום בתחרות': 'You joined the waiting list! 📋 You will be notified when a spot opens',
  'ההרשמה בוטלה בהצלחה (ללא דמי ביטול)': 'Registration cancelled (no cancellation fee)',
  'לא ניתן להירשם לתחרות שכבר בעיצומה': 'Cannot register for a tournament already in progress',
  'התחרות כבר החלה - לא ניתן להירשם': 'Tournament already started — registration closed',
  'התחרות הסתיימה': 'Tournament finished',
  '🎉 התחרות הסתיימה!': '🎉 Tournament finished!',
  'יש להזין שם פרטנר לפני ההרשמה לתחרות זוגות': 'Enter a partner name before registering for doubles',
  'הכנס שם פרטנר...': 'Enter partner name...',
  'שחקן 1': 'Player 1',
  'שחקן 2 (פרטנר)': 'Player 2 (partner)',
  'שם מלא *': 'Full name *',
  'טלפון (אופציונלי)': 'Phone (optional)',
  'מיקום': 'Location',
  'נק׳': 'pts',
  'שיטת משחקים:': 'Match format:',
  '🗓️ שיטת התחרות:': '🗓️ Tournament format:',
  '📋 שיטת התחרות והמשחקים:': '📋 Tournament & match format:',
  'שיטת התחרות והמשחקים': 'Tournament & match format',
  '✨ פרטי התחרות:': '✨ Tournament details:',
  'שלב בתים (4 בתים של 4 שחקנים)': 'Group stage (4 groups of 4 players)',
  '2 עולים מכל בית לשלב נוקאאוט': 'Top 2 from each group advance to knockout',
  'הטוב מ-3 מערכות, הסט השלישי הוא סופר טייבריק': 'Best of 3 sets, third set is a super tiebreak',
  'משחקים מ-2:2 עד סט מלא': 'Games from 2:2 up to a full set',
  'מפסידים בסיבוב הראשון בלבד יורדים לטורניר תנחומים, והמנצח בו יזכה בפרס!': 'First-round losers drop to the consolation bracket — its winner gets a prize!',
  'התחרות תימשך כחודש וחצי, ובמהלך כל שבוע אחד חובה לשחק שלב אחד לפחות.': 'The tournament runs about a month and a half; at least one round must be played each week.',
  'השחקנים אחראים לקבוע ביניהם מיקום ושעה שמתאימים לשניהם.': 'Players are responsible for agreeing on a time and place together.',
  'אם אין הסכמה, מנהל התחרות יקבע מיקום ושעה נייטרליים.': 'If there is no agreement, the tournament manager will set a neutral time and place.',
  'השחקנים אחראים להזמין מגרש ולשאת בעלות השכרת המגרש + הכדורים.': 'Players are responsible for booking a court and covering court + balls costs.',
  'חובה על המנצח לעדכן את התוצאה למנהל התחרות.': 'The winner must report the result to the tournament manager.',
  'מי שלא יופיע – מפסיד טכני!': 'No-shows lose by walkover!',
  '(ייתכנו שינויים בהתאם לזמנים)': '(subject to schedule changes)',
  '(חובה)': '(required)',
  'טיפ:': 'Tip:',
  'להצטרפות לקבוצה של התחרות (חובה לעדכונים):': 'Join the tournament group (required for updates):',
  'כל התוצאות שלב אחרי שלב': 'All results, round by round',

  // Bracket
  'ברקט התחרות': 'Tournament Bracket',
  '🎾 ברקט התחרות - טניס פרו ישראל': '🎾 Tournament Bracket - Tennis Pro Israel',
  'טוען ברקט...': 'Loading bracket...',
  'שגיאה בטעינת הברקט': 'Error loading bracket',
  'שמינית גמר': 'Round of 16',
  'רבע גמר': 'Quarterfinals',
  'חצי גמר': 'Semifinals',
  'גמר': 'Final',
  'משחק הגמר': 'Final match',
  'שמינית גמר תנחומים': 'Consolation round of 16',
  'רבע גמר תנחומים': 'Consolation quarterfinals',
  'חצי גמר תנחומים': 'Consolation semifinals',
  '🏆 גמר תנחומים 🏆': '🏆 Consolation final 🏆',
  'אלוף התנחומים': 'Consolation champion',
  '🎗️ אלוף התנחומים:': '🎗️ Consolation champion:',
  '🥈 סגן אלוף:': '🥈 Runner-up:',
  'אלוף הטורניר': 'Tournament champion',
  'ממתין': 'Waiting',
  'ממתין למפסיד': 'Waiting for loser',
  'המנצח': 'Winner',
  'מנצח המשחק': 'Match winner',
  'היריב': 'Opponent',
  'משחקים': 'Matches',
  'ניצחונות במשחקים': 'Match wins',
  'הפסדים במשחקים': 'Match losses',
  'משחקונים שניצח (games won)': 'Games won',
  'משחקונים שהפסיד (games lost)': 'Games lost',
  'נצ׳': 'W',
  'הפ׳': 'L',
  'משחק כל אחד נגד כל אחד': 'Round robin — everyone plays everyone',
  '🎾 שלב בתים': '🎾 Group stage',
  'שלבי הפלייאוף': 'Playoff rounds',
  '🔀 הצלבות לרבע גמר': '🔀 Quarterfinal cross-matches',
  'איך זה עובד?': 'How does it work?',
  'הזנת תוצאה': 'Enter result',
  'תוצאה רגילה': 'Regular result',
  'סוג סיום': 'Finish type',
  'פרישה': 'Retirement',
  '🤕 פרישה': '🤕 Retirement',
  'אחד פרש': 'One retired',
  'לא הופיע למשחק': 'Did not show up',
  'W.O. (עלה אוטומטית)': 'W.O. (advanced automatically)',
  'עלה אוטומטית —': 'Advanced automatically —',
  'עלה אוטו׳': 'Auto advance',
  'התוצאה נשמרה בהצלחה!': 'Result saved!',
  'שגיאה בשמירת התוצאה': 'Error saving result',
  'תוצאת המשחק אופסה!': 'Match result was reset!',
  'האם לאפס את תוצאת המשחק? הפעולה תמחק את התוצאה ואת ההתקדמות לשלב הבא.': 'Reset this match result? This deletes the result and the advancement to the next round.',
  'נא לבחור מנצח': 'Please pick a winner',
  'עליך להיות מחובר כדי להזין תוצאות': 'You must be logged in to enter results',
  'רק מנהלים או שחקנים במשחק יכולים להזין תוצאה': 'Only admins or the match players can enter a result',
  'רק מנהל יכול לערוך תוצאה קיימת': 'Only an admin can edit an existing result',
  'דוגמאות לתוצאות תקינות:': 'Examples of valid scores:',
  'תחרות יומית: מערכה אחת בלבד (1 סט)': 'Daily tournament: one set only',
  'תחרות נוקאאוט: 2 סטים מינימום, 3 מקסימום': 'Knockout: 2 sets minimum, 3 maximum',
  'מערכה שלישית: סופר טייברייק (10-8, 11-9, ועד 20-18 לפי הצורך)': 'Third set: super tiebreak (10-8, 11-9, up to 20-18 as needed)',
  'שגיאות ולידציה:': 'Validation errors:',
  'הברקט עודכן בזמן אמת!': 'Bracket updated in real time!',
  'ה-PDF הורד בהצלחה 📄': 'PDF downloaded 📄',
  'מכין PDF...': 'Preparing PDF...',
  'מכין תמונה...': 'Preparing image...',
  'התמונה הורדה בהצלחה 📸': 'Image downloaded 📸',
  'שגיאה בהכנת ה-PDF': 'Error preparing PDF',
  'שגיאה בהכנת התמונה': 'Error preparing image',
  'שחזור הטורניר מתחיל... 🍿': 'Tournament replay starting... 🍿',
  'הסרטון שותף! 🎬': 'Video shared! 🎬',
  'הסרטון הורד - שתף אותו בוואטסאפ/אינסטגרם 🎾': 'Video downloaded — share it on WhatsApp/Instagram 🎾',
  'שגיאה ביצירת הסרטון': 'Error creating video',
  'כל הכבוד לכל המשתתפים! 👏': 'Well done to all participants! 👏',
  '📸 רגעים מהמגרש': '📸 Moments from the court',
  'התמונות האחרונות מהתחרויות': 'Latest photos from tournaments',
  'מסלול מיוחד': 'Special path',
  'זוכה בפרס התנחומים + 50 נקודות בונוס!': 'Wins the consolation prize + 50 bonus points!',
  'קיים': 'Exists',
  '+ שותף/ה': '+ partner',
  '4 שחקנים': '4 players',

  // Win prediction
  'סיכוי לנצח': 'Win chance',
  'מחשב חיזוי...': 'Calculating prediction...',
  'אין נתונים': 'No data',
  'מפגש ישיר': 'Head to head',
  'מצב נוכחי': 'Current form',
  'אמינות גבוהה': 'High confidence',
  'אמינות בינונית': 'Medium confidence',
  'אמינות נמוכה': 'Low confidence',
});

// dynamic tournament strings
REGEX_RULES.push(
  [/^(.+) נוסף לבית (.+)!$/, '$1 was added to group $2!'],
  [/^(.+) הוסר מהבית$/, '$1 was removed from the group'],
  [/^(.+) הועבר לבית (.+)$/, '$1 was moved to group $2'],
  [/^להסיר את (.+) מהבית\?$/, 'Remove $1 from the group?'],
  [/^להסיר את (.+) מהתחרות\?$/, 'Remove $1 from the tournament?'],
  [/^להסיר את (.+) מהמשחק\?$/, 'Remove $1 from the match?'],
  [/^(.+) הוסר מהמשבצת$/, '$1 was removed from the slot'],
  [/^(.+) הוסר מרשימת ההמתנה$/, '$1 was removed from the waiting list'],
  [/^בית (\d+)$/, 'Group $1'],
  [/^בית (\d+) מקום ראשון 🆚 בית (\d+) מקום שני$/, 'Group $1 winner 🆚 Group $2 runner-up'],
  [/^⏳ רשימת המתנה \((\d+)\)( — מומלץ!)?$/, '⏳ Waiting list ($1)'],
  [/^נבחר: (.+)$/, 'Selected: $1'],
  [/^העבר לבית (.+)$/, 'Move to group $1'],
  [/^משחק (\d+)( \(עליון\)| \(תחתון\))?:$/, 'Match $1:'],
  [/^(\d+) שחקנים$/, '$1 players'],
  [/^🏆 (.+) - אלוף (.+)$/, '🏆 $1 — champion of $2'],
);

// ===== Auth / Profile / Community pages =====
Object.assign(DICT, {
  // Auth
  'התחבר/י עם Google': 'Sign in with Google',
  'או עם אימייל': 'or with email',
  'אימייל *': 'Email *',
  'סיסמא': 'Password',
  'סיסמא *': 'Password *',
  'אימות סיסמא': 'Confirm password',
  'אימות סיסמא *': 'Confirm password *',
  'סיסמא חדשה': 'New password',
  'הסיסמאות אינן זהות': 'Passwords do not match',
  'הסיסמא שונתה בהצלחה!': 'Password changed successfully!',
  'נשלח קוד איפוס לאימייל שלך!': 'A reset code was sent to your email!',
  'קוד איפוס (6 תווים)': 'Reset code (6 characters)',
  'שכחתי סיסמא': 'Forgot password',
  'טלפון *': 'Phone *',
  'טלפון': 'Phone',
  'עיר': 'City',
  'תל אביב': 'Tel Aviv',
  'שנת לידה': 'Year of birth',
  'לדוגמה: 1990': 'e.g. 1990',
  'רמת משחק *': 'Playing level *',
  'אנא בחר רמת משחק': 'Please choose a playing level',
  'דרג א (רמה 4-5)': 'Level A (rating 4-5)',
  'דרג ב (רמה 5-6)': 'Level B (rating 5-6)',
  'דרג ג (רמה 6-7)': 'Level C (rating 6-7)',
  'יחידים Open (רמה 3-4)': 'Singles Open (rating 3-4)',
  'זוגות Open (כל הרמות)': 'Doubles Open (all levels)',
  'נשים (רמה 5-7)': 'Women (rating 5-7)',
  'פרטים נוספים (אופציונלי)': 'More details (optional)',
  'יד משחק': 'Playing hand',
  'בחר יד': 'Choose hand',
  'ימין': 'Right',
  'שמאל': 'Left',
  'שתי ידיים': 'Two-handed',
  'משטח אהוב': 'Favorite surface',
  'בחר משטח': 'Choose surface',
  'חימר (Clay)': 'Clay',
  'דשא (Grass)': 'Grass',
  'קשה (Hard Court)': 'Hard Court',
  'קשה (Hard)': 'Hard',
  'שטיח (Carpet)': 'Carpet',
  'כמה שנים משחק/ת טניס': 'Years playing tennis',
  'כמה שנים את/ה משחק/ת?': 'How many years have you played?',
  'נרשמת בהצלחה! נשלח אליך מייל עם פרטי החשבון': 'Registered! An email with your account details was sent',

  // Profile
  'עריכת פרופיל': 'Edit Profile',
  'הפרופיל עודכן בהצלחה!': 'Profile updated!',
  'הפרופיל עודכן בהצלחה! 🎉': 'Profile updated! 🎉',
  'שגיאה בעדכון הפרופיל': 'Error updating profile',
  'שגיאה בטעינת פרופיל': 'Error loading profile',
  'השחקן לא נמצא': 'Player not found',
  'אודות': 'About',
  'ניצחונות': 'Wins',
  'הפסדים': 'Losses',
  'תחרויות': 'Tournaments',
  'עוקבים': 'Followers',
  'עוקב': 'Following',
  'דירוג': 'Rank',
  'היסטוריית תחרויות': 'Tournament history',
  'אין היסטוריית תחרויות עדיין': 'No tournament history yet',
  'תוצאות מצטיינות': 'Top results',
  'תוצאה:': 'Result:',
  'תחרויות יומיות:': 'Daily tournaments:',
  'נוקאאוט:': 'Knockout:',
  '📊 מאפייני משחק': '📊 Playing profile',
  '🎾 ציוד ומטרות': '🎾 Gear & goals',
  'סגנון משחק': 'Playing style',
  'בחר סגנון': 'Choose style',
  'בחר סגנון משחק': 'Choose playing style',
  'בחר קטגוריה': 'Choose category',
  'אגרסיבי מאחור (Aggressive Baseliner)': 'Aggressive Baseliner',
  'הגנתי מאחור (Defensive Baseliner)': 'Defensive Baseliner',
  'הגשה ועליה (Serve & Volley)': 'Serve & Volley',
  "קאנטר פאנצ'ר (Counter Puncher)": 'Counter Puncher',
  'שחקן כל המגרש (All-Court)': 'All-Court Player',
  'שחקן עקבי (Consistent)': 'Consistent Player',
  'מכות חזקות (Big Hitter)': 'Big Hitter',
  'נקודות חזקות': 'Strengths',
  'נקודות לשיפור': 'Areas to improve',
  'רקטה': 'Racket',
  'נעליים': 'Shoes',
  'שנות משחק': 'Years playing',
  'שחקן מועדף #1': 'Favorite player #1',
  'שחקן מועדף #2': 'Favorite player #2',
  'שחקן מועדף #3': 'Favorite player #3',
  'מטרות לעונה:': 'Season goals:',
  'לא הוזנו מטרות': 'No goals set',
  'ערוך תיאור': 'Edit bio',
  'ערוך רשתות חברתיות': 'Edit social links',
  '📱 רשתות חברתיות': '📱 Social links',
  'הוסף קישורים כדי שאנשים יוכלו ליצור איתך קשר': 'Add links so people can reach you',
  'לחץ לפתיחת WhatsApp': 'Tap to open WhatsApp',
  'תמונה נטענה! לא לשכוח לשמור': "Image loaded! Don't forget to save",
  'יש לבחור קובץ תמונה בלבד': 'Please choose an image file only',
  'הקובץ גדול מדי. מקסימום 5MB': 'File too large. Max 5MB',
  'שגיאה בקריאת התמונה': 'Error reading image',
  'ההודעה נשלחה!': 'Message sent!',
  'שגיאה בשליחת הודעה': 'Error sending message',
  'נושא': 'Subject',
  'תוכן ההודעה': 'Message content',
  'נושא ותוכן נדרשים': 'Subject and content are required',
  'כתוב את ההודעה שלך...': 'Write your message...',
  'עליך להיות מחובר': 'You must be logged in',
  'ספר/י קצת על עצמך, סגנון המשחק שלך, מטרות...': 'Tell us about yourself, your playing style, goals...',
  'ספר/י קצת על עצמך, סגנון המשחק שלך, הישגים...': 'Tell us about yourself, your playing style, achievements...',

  // Partner board
  '🎾 מחפש שותף': '🎾 Looking for a partner',
  'מצא פרטנר למשחק — פרסם מודעה או הגב למודעה קיימת בצ\'אט': 'Find a playing partner — post an ad or reply to one in chat',
  '🎾 מודעה חדשה': '🎾 New post',
  'מה אתה מחפש? *': 'What are you looking for? *',
  'כתוב מה אתה מחפש 🎾': 'Write what you are looking for 🎾',
  'ספר לקהילה מה אתה מחפש': 'Tell the community what you need',
  'אזור / מגרש': 'Area / court',
  'מתי נוח לך?': 'When suits you?',
  'תאריך המשחק': 'Match date',
  'רמה *': 'Level *',
  'יש לבחור רמה': 'Please choose a level',
  'טלפון לווצאפ (לא חובה)': 'WhatsApp phone (optional)',
  'אם תוסיף - יופיע כפתור ווצאפ ירוק על המודעה': 'If added — a green WhatsApp button will appear on the post',
  'המודעה פורסמה! 🎾': 'Post published! 🎾',
  'המודעה נמחקה': 'Post deleted',
  'למחוק את המודעה?': 'Delete this post?',
  'שגיאה בפרסום': 'Error publishing',
  'התחבר כדי לפרסם מודעה': 'Log in to publish a post',
  'התחבר כדי להגיב': 'Log in to reply',
  'נמצא שותף 🎉': 'Partner found 🎉',
  'מעולה! שיהיה משחק טוב 🎾': 'Great! Have a good match 🎾',
  '🎉 מצאו שותף לאחרונה': '🎉 Recently found partners',

  // Coaches
  'אין מאמנים עדיין': 'No coaches yet',
  'היה הראשון להירשם כמאמן באתר!': 'Be the first coach to register!',
  'חפש מאמן לפי שם או עיר...': 'Search coach by name or city...',
  'כל האזורים': 'All regions',
  'כל ההתמחויות': 'All specialties',
  'מרכז': 'Center',
  'צפון': 'North',
  'דרום': 'South',
  'שרון': 'Sharon',
  'ירושלים': 'Jerusalem',
  'ילדים': 'Kids',
  'ילדים ונוער': 'Kids & youth',
  'מבוגרים': 'Adults',
  'מתחילים': 'Beginners',
  'מתקדמים': 'Advanced',
  'תחרותי': 'Competitive',
  'טניס תחרותי': 'Competitive tennis',
  'הירשם כמאמן': 'Register as a coach',
  'מלא את הפרטים ותופיע ברשימת המאמנים של Tennis Pro Israel': 'Fill in your details to appear in the Tennis Pro Israel coach list',
  'הבקשה נשלחה בהצלחה!': 'Request sent!',
  'שגיאה בשליחת הבקשה': 'Error sending request',
  'עליך להיות מחובר כדי להירשם כמאמן': 'You must be logged in to register as a coach',
  'עליך להיות מחובר כדי להירשם כמאמן באתר': 'You must be logged in to register as a coach',
  'השם המלא שלך': 'Your full name',
  'שם העיר': 'City name',
  'בחר אזור': 'Choose region',
  'מועדון / מרכז טניס': 'Club / tennis center',
  'הסמכות מקצועיות': 'Professional certifications',
  'הסמכות': 'Certifications',
  'הסמכות:': 'Certifications:',
  'התמחויות': 'Specialties',
  'זמינות': 'Availability',
  'זמינות:': 'Availability:',
  'ימים א-ה, בוקר/ערב': 'Sun-Thu, mornings/evenings',
  'מחירון': 'Pricing',
  'אימון פרטי': 'Private lesson',
  'אימון זוגי': 'Duo lesson',
  'אימון קבוצתי': 'Group lesson',
  'מחיר פרטי': 'Private price',
  'מחיר זוגי': 'Duo price',
  'מחיר קבוצתי': 'Group price',
  'פרטי:': 'Private:',
  'זוגי:': 'Duo:',
  'קבוצתי:': 'Group:',
  'שנות ניסיון': 'Years of experience',
  'תיאור': 'Description',
  'מועדון': 'Club',
  'מועדון:': 'Club:',
  'אזור': 'Region',
  'אימייל:': 'Email:',
  'WhatsApp (מספר)': 'WhatsApp (number)',
  'רשתות חברתיות': 'Social links',
  'לחץ להעלאת תמונה (עד 5MB)': 'Tap to upload a photo (up to 5MB)',
  'התמונה גדולה מדי (מקסימום 5MB)': 'Image too large (max 5MB)',
  'ספר על עצמך, הניסיון שלך, סגנון האימון...': 'Tell us about yourself, your experience, coaching style...',
  'מאמן לא נמצא': 'Coach not found',
  'לא ניתן לטעון את פרטי המאמן': 'Could not load coach details',
  'חזרה לרשימת המאמנים': 'Back to coach list',
  'הצטרף באתר:': 'Joined:',
  'אין צפיות עדיין': 'No views yet',
  'כתוב ביקורת': 'Write a review',
  'ספר על החוויה שלך עם המאמן...': 'Tell us about your experience with this coach...',
  'הביקורת נוספה בהצלחה!': 'Review added!',
  'הביקורת נמחקה': 'Review deleted',
  'מחק ביקורת': 'Delete review',
  'למחוק את הביקורת הזו?': 'Delete this review?',
  'שגיאה בשליחת הביקורת': 'Error sending review',
  'שגיאה במחיקת הביקורת': 'Error deleting review',
  'אנא בחר דירוג (כוכבים)': 'Please choose a star rating',
  'עליך להיות מחובר כדי לכתוב ביקורת': 'You must be logged in to write a review',

  // Camps
  'למה בלגרד?': 'Why Belgrade?',
  'למה דובאי?': 'Why Dubai?',
  'למה מונטנגרו?': 'Why Montenegro?',
  'מה כולל המחנה': "What's included",
  '10 אימוני טניס עם מאמנים בכירים': '10 tennis sessions with senior coaches',
  'מלון 4-5 כוכבים במרכז העיר': '4-5 star hotel in the city center',
  'מאמן ישראלי מלווה': 'Accompanying Israeli coach',
  'הסעות לכל הצרכים': 'Transportation included',
  'אטרקציות וחוויות': 'Attractions & experiences',
  'יש לכם שאלות?': 'Have questions?',
  'תאריכים:': 'Dates:',
  '💰 מחירים': '💰 Prices',
  'מחיר חדר יחיד:': 'Single room price:',
  'מחיר חדר זוגי:': 'Double room price:',
  'משך המחנה (לילות/ימים):': 'Camp length (nights/days):',
  'בחר יעד *': 'Choose destination *',
  'בחר יעד...': 'Choose destination...',
  'סוג חדר *': 'Room type *',
  'בחר סוג חדר...': 'Choose room type...',
  '🛏️ חדר יחיד': '🛏️ Single room',
  '🛏️🛏️ חדר זוגי': '🛏️🛏️ Double room',
  '⛰️ מונטנגרו': '⛰️ Montenegro',
  '🏛️ בלגרד, סרביה': '🏛️ Belgrade, Serbia',
  '🏜️ דובאי, איחוד האמירויות': '🏜️ Dubai, UAE',
  'גיל *': 'Age *',
  'שם מלא בעברית *': 'Full name in Hebrew *',
  'שם מלא באנגלית (כמו בדרכון) *': 'Full name in English (as in passport) *',
  'כתובת אימייל *': 'Email address *',
  'אופן תשלום': 'Payment method',
  '💵 מזומן בלבד': '💵 Cash only',
  'הצהרת בריאות *': 'Health declaration *',
  'הצהרה משפטית *': 'Legal declaration *',
  'חתימה דיגיטלית *': 'Digital signature *',
  'הקלד את שמך המלא כחתימה': 'Type your full name as a signature',
  'פרטים אישיים ופרטי מחנה': 'Personal & camp details',
  'שלח הרשמה לווצאפ 📱': 'Send registration to WhatsApp 📱',
  'שולח...': 'Sending...',
  'הטופס נשלח בהצלחה!': 'Form sent successfully!',

  // Levels & Points
  'מידע כללי': 'General info',
  'תחרות שמתחילה ומסתיימת באותו היום': 'A tournament that starts and ends the same day',
  'עד 16 שחקנים בכל קטגוריה': 'Up to 16 players per category',
  'עד 32 שחקנים בכל קטגוריה': 'Up to 32 players per category',
  'חלוקה ל-4 בתים של 4 שחקנים': 'Split into 4 groups of 4 players',
  '2 עולים מכל בית לנוקאאוט (רבע, חצי, גמר)': 'Top 2 per group advance to knockout (QF, SF, F)',
  'משחקים עד 2:2 סט מלא': 'Games from 2:2 to a full set',
  'הטוב מ-3 מערכות (סט שלישי סופר טייברייק)': 'Best of 3 sets (third set super tiebreak)',
  'שמינית גמר → רבע גמר → חצי גמר → גמר': 'Round of 16 → Quarterfinals → Semifinals → Final',
  'תחרויות נוקאאוט ארוכות:': 'Long knockout tournaments:',
  'הרשמה ורשימת המתנה:': 'Registration & waiting list:',
  'הרשמה אונליין בלחיצת כפתור': 'Online registration in one click',
  'רשימת המתנה אוטומטית אם התחרות מלאה': 'Automatic waiting list when full',
  'הגרלה אוטומטית ברגע שהרשימה מתמלאת': 'Automatic draw once the list fills up',
  'אפשרות לבטל הרשמה עד תחילת התחרות': 'Cancel registration until the tournament starts',
  'ברקט נוקאאוט אינטראקטיבי באתר': 'Interactive knockout bracket on the site',
  'השתתפות': 'Participation',
  'חצי גמר': 'Semifinal',
  'רבע הגמר': 'Quarterfinal',
  '🎯 רבע גמר': '🎯 Quarterfinal',
  '🏅 חצי גמר': '🏅 Semifinal',
  '🏅 מקום 4': '🏅 4th place',
  '📊 שמינית גמר': '📊 Round of 16',
  '📋 סיבוב ראשון': '📋 First round',
  '📋 שלב בתים': '📋 Group stage',
  '🥇 מקום 1': '🥇 1st place',
  '🥈 מקום 2': '🥈 2nd place',
  '🥉 מקום 3': '🥉 3rd place',
  'השלב שהגיע אליו:': 'Stage reached:',
  'השלב הסופי': 'Final stage',
  'נקודות:': 'Points:',
  'שים לב:': 'Note:',
  '⚠️ חשוב להבין!': '⚠️ Important!',
  'פרסים נוספים': 'More prizes',
  'הגעה לחצי גמר': 'Reaching the semifinal',
  'דוגמה 1: מנצח יומית 🥇': 'Example 1: daily winner 🥇',
  'דוגמה 2: חצי גמר יומית 🏅': 'Example 2: daily semifinal 🏅',
  'דוגמה 3: מנצח נוקאאוט 🏆': 'Example 3: knockout winner 🏆',
  '💪 אסטרטגיה 1: עקביות': '💪 Strategy 1: consistency',
  '🏆 אסטרטגיה 2: איכות': '🏆 Strategy 2: quality',
  '🎯 אסטרטגיה 3: השוואה מהירה': '🎯 Strategy 3: quick comparison',

  // Contact & community
  'שלח לנו הודעה': 'Send us a message',
  'הודעה': 'Message',
  'כתוב כאן את ההודעה שלך...': 'Write your message here...',
  'ההודעה נשלחה בהצלחה!': 'Message sent!',
  'וואטסאפ': 'WhatsApp',
  'לחץ לשיחה ישירה': 'Tap for a direct chat',
  'לחץ לחיוג ישיר 📞': 'Tap to call 📞',
  'לחץ לשליחת מייל ישיר ✉️': 'Tap to send an email ✉️',
  'ברוכים הבאים לקהילה!': 'Welcome to the community!',
  'יש שאלות?': 'Questions?',
  'כבוד הדדי:': 'Mutual respect:',
  'ללא ספאם:': 'No spam:',
  'רלוונטיות:': 'Stay on topic:',
  'שפה נאותה:': 'Appropriate language:',
  'ציוד טניס - קנייה ומכירה': 'Tennis gear — buy & sell',
  'תיאום משחקים טניס': 'Tennis match scheduling',

  // Leaderboards
  'טוען מובילים...': 'Loading leaders...',
  'אין נתונים להצגה': 'No data to show',
  'אחוז ניצחון': 'Win rate',
  'רצף': 'Streak',
  'רצף ניצחונות': 'Win streak',
  'כל הדרגות': 'All levels',
  'שגיאה בטעינת לוחות מובילים': 'Error loading leaderboards',
});

Object.assign(DICT, {
  'קהילת הטניס המובילה בישראל': "Israel's leading tennis community",
  'הגדולה בישראל': 'The largest in Israel',
  'תחרויות יומיות · דירוג שחקנים · פרסים מדהימים · קהילה משגשגת': 'Daily tournaments · Player rankings · Amazing prizes · A thriving community',
  'הצטרפו לקהילה': 'Join the community',
});

// ===== Iteration 45 gap fixes =====
Object.assign(DICT, {
  'דברו איתנו בוואטסאפ': 'Chat with us on WhatsApp',
  // Home feature cards & camps section
  'תחרויות שמתחילות ומסתיימות באותו היום. עד 16 שחקנים בכל קטגוריה.': 'Tournaments that start and end the same day. Up to 16 players per category.',
  'תחרויות ארוכות עד 32 שחקנים עם מערכת נוקאאוט מלאה ופרסים גדולים.': 'Long tournaments of up to 32 players with a full knockout system and big prizes.',
  'מערכת דירוג מתעדכנת אחרי כל תחרות עם ניקוד וסטטיסטיקות מפורטות.': 'A ranking system updated after every tournament with points and detailed stats.',
  'מחנות אימונים בחו״ל': 'Training camps abroad',
  'במחנה אימונים בחו״ל': 'at a training camp abroad',
  'שדרגנו את המשחק': 'Level up your game',
  'חוויה בלתי נשכחת המשלבת אימוני טניס מקצועיים עם מאמנים מקומיים בעלי ניסיון בינלאומי, בליווי מאמן ישראלי לאורך כל המחנה.': 'An unforgettable experience combining professional tennis training with internationally experienced local coaches, accompanied by an Israeli coach throughout the camp.',
  'ראה את כל המחנות': 'See all camps',
  'היעדים שלנו': 'Our destinations',
  'בלגרד': 'Belgrade',
  'סרביה': 'Serbia',
  'מסורת טניס עשירה': 'A rich tennis tradition',
  'מונטנגרו': 'Montenegro',
  'הר השחור': 'The Black Mountain',
  'חופים והרים מרהיבים': 'Stunning beaches and mountains',
  'דובאי': 'Dubai',
  'איחוד האמירויות': 'United Arab Emirates',
  'יוקרה ומתקנים מתקדמים': 'Luxury and advanced facilities',
  '4 קבוצות פעילות לתיאום משחקים, ציוד, תחרויות ושיחות טניס': '4 active groups for match scheduling, gear, tournaments and tennis talk',
  '🎾 תחרויות פעילות וקרובות': '🎾 Active & Upcoming Tournaments',
  'גברים': 'Men',
  'נוקאאוט': 'Knockout',
  '· נוקאאוט 🏆': '· Knockout 🏆',
  'יומית': 'Daily',
  // Rankings
  'דירוג כללי': 'Overall ranking',
  'שחקנים': 'Players',
  // Tournaments
  '💳 לתשלום דרך Paybox': '💳 Pay via Paybox',
  'עד 32 שחקנים · מערכת נוקאאוט מלאה': 'Up to 32 players · full knockout system',
  '🏆 מנצחים ממשיכים, מפסידים נלחמים בתנחומים — הדרך לגביע עוברת כאן': '🏆 Winners advance, losers fight in the consolation — the road to the trophy runs through here',
  // Partner board
  'קהילת השחקנים': 'Player community',
  'אין מודעות כרגע — היה הראשון לפרסם!': 'No posts yet — be the first to publish!',
  // Coaches
  'מצא מאמן טניס': 'Find a Tennis Coach',
  'המאמנים הטובים ביותר בישראל במקום אחד. מצא את המאמן המושלם עבורך והתחל להשתפר!': 'The best coaches in Israel in one place. Find your perfect coach and start improving!',
  'הירשם כמאמן באתר': 'Register as a coach',
  'התקשר': 'Call',
  // Training camps
  'מחנות אימונים לחו"ל': 'Training Camps Abroad',
  'חווית אימונים בינלאומית במיטב המתקנים בעולם': "An international training experience at the world's best facilities",
  'שלושה יעדים מובחרים לשדרוג המשחק שלך לרמה הבאה': 'Three select destinations to take your game to the next level',
  'מה כולל כל מחנה?': "What's included in each camp?",
  'עיר הטניס האירופית - בירת מדינת הטניס של נובאק ג׳וקוביץ׳': "Europe's tennis city — the capital of Novak Djokovic's tennis nation",
  'מזג אויר אידיאלי לטניס רוב השנה': 'Ideal tennis weather most of the year',
  'מתקני טניס ברמה עולמית': 'World-class tennis facilities',
  'עלות מחיה נמוכה יחסית': 'Relatively low cost of living',
  'סביבה תחרותית עם שחקנים ברמה גבוהה': 'A competitive environment with high-level players',
  '3 לילות - 4 ימים (סופ״ש)': '3 nights - 4 days (weekend)',
  // WhatsApp community
  'קהילת הטניס בוואטסאפ': 'The Tennis Community on WhatsApp',
  'הצטרפו לקבוצות הוואטסאפ הפעילות שלנו': 'Join our active WhatsApp groups',
  'תיאום משחקים, ציוד, תחרויות ופורום כללי': 'Match scheduling, gear, tournaments and a general forum',
  'הקבוצות שלנו פעילות 24/7 עם מאות חברים שאוהבים טניס כמוך. בחר את הקבוצה המתאימה לך והצטרף עכשיו!': 'Our groups are active 24/7 with hundreds of members who love tennis like you. Pick your group and join now!',
  'תיאום משחקים לפי רמות - מצא שותפים לאימון': 'Match scheduling by level — find training partners',
  'קנייה ומכירה של ציוד חדש או יד שנייה': 'Buy & sell new or used gear',
  'עדכונים שוטפים על תחרויות קרובות ותוצאות': 'Ongoing updates on upcoming tournaments and results',
  'חיים, נושמים ומדברים טניס - הפורום הכללי שלנו': 'Living, breathing and talking tennis — our general forum',
  'כללי הקבוצות': 'Group rules',
  'התייחסו בכבוד לכל חברי הקבוצה': 'Treat all group members with respect',
  'שמרו על תוכן רלוונטי לנושא הקבוצה': "Keep content relevant to the group's topic",
  'הימנעו משליחת הודעות שיווקיות לא רלוונטיות': 'Avoid sending irrelevant marketing messages',
  'השתמשו בשפה מכבדת וללא קללות': 'Use respectful language, no profanity',
  'צרו איתנו קשר לכל שאלה או בקשה': 'Contact us with any question or request',
  // Levels
  'הסבר רמות': 'Levels Guide',
  'הבנת הקטגוריות והרמות השונות בתחרויות': 'Understanding the categories and levels in our tournaments',
  'כל הרמות': 'All levels',
  'תחרות זוגות פתוחה לכל הרמות. מתאים לשחקנים בכל רמה.': 'A doubles tournament open to all levels. Suitable for players of any level.',
  'תחרות יחידים לשחקנים ברמה גבוהה. משחק אינטנסיבי ותחרותי.': 'A singles tournament for high-level players. Intense, competitive play.',
  'שחקנים בעלי רמה גבוהה-בינונית. משחק טקטי וטכני מוצק.': 'Upper-intermediate players. Solid tactical and technical play.',
  'שחקנים ברמה בינונית. שליטה במכות הבסיסיות והתחלת משחק טקטי.': 'Intermediate players. Command of the basic strokes and early tactical play.',
  'שחקנים מתחילים-בינוניים. מתאים למי שרוצה להתחיל לשחק בתחרויות.': 'Beginner-intermediate players. Great for anyone starting out in tournaments.',
  'תחרות נשים בלבד. מתאים לכל הרמות ממתחילות עד מתקדמות.': 'Women-only tournament. Suitable for all levels, beginners to advanced.',
  // Points system
  'מערכת הניקוד': 'The Points System',
  'מבוסס על מודל ATP עם התאמות לתחרויות שלנו': 'Based on the ATP model, adapted to our tournaments',
  '2 עולים מכל בית': 'Top 2 advance from each group',
  'מתוך 16 הטובים': 'Of the top 16',
  'כל שחקן מקבל רק את הנקודות של השלב הסופי שהגיע אליו.': 'Each player receives only the points for the final stage they reached.',
  'לדוגמה: מנצח מקבל רק': 'For example: the winner receives only',
  '(לא צבירה מכל השלבים)': '(not a sum of all stages)',
  // Contact
  'צור קשר': 'Contact Us',
  'נשמח לעמוד לשירותך': 'We are happy to help',
  'שלח הודעה': 'Send message',
  'פתח וואטסאפ 💬': 'Open WhatsApp 💬',
  // Auth
  'התחברות': 'Login',
  'היכנס לחשבון שלך': 'Sign in to your account',
  'זכור אותי (הישאר מחובר)': 'Remember me (stay signed in)',
  'היכנס': 'Sign in',
  'אין לך חשבון? הירשם עכשיו': "Don't have an account? Sign up now",
  'יש לך חשבון? התחבר': 'Already have an account? Log in',
  // Standalone date words (own DOM nodes on calendar cards)
  'שבת': 'Sat',
  "יום א'": 'Sun', "יום ב'": 'Mon', "יום ג'": 'Tue', "יום ד'": 'Wed', "יום ה'": 'Thu', "יום ו'": 'Fri',
  'יום ראשון': 'Sunday', 'יום שני': 'Monday', 'יום שלישי': 'Tuesday', 'יום רביעי': 'Wednesday',
  'יום חמישי': 'Thursday', 'יום שישי': 'Friday',
  'ינואר': 'January', 'פברואר': 'February', 'מרץ': 'March', 'אפריל': 'April', 'מאי': 'May',
  'יוני': 'June', 'יולי': 'July', 'אוגוסט': 'August', 'ספטמבר': 'September', 'אוקטובר': 'October',
  'נובמבר': 'November', 'דצמבר': 'December',
  "ינו'": 'Jan', "פבר'": 'Feb', "אפר'": 'Apr', "אוג'": 'Aug', "ספט'": 'Sep', "אוק'": 'Oct',
  "נוב'": 'Nov', "דצמ'": 'Dec',
});

REGEX_RULES.push(
  [/^רמה (\d+)-(\d+)$/, 'Rating $1-$2'],
  [/^תחרויות יומיות \((\d+) שחקנים\)$/, 'Daily tournaments ($1 players)'],
  [/^תחרויות נוקאאוט \(עד (\d+) שחקנים\)$/, 'Knockout tournaments (up to $1 players)'],
  [/^גביע \+ שובר ([\d,]+) ₪$/, 'Trophy + ₪$1 voucher'],
  [/^שובר ([\d,]+) ₪$/, '₪$1 voucher'],
  [/^([\d,]+) ש"ח$/, '₪$1'],
  [/^עד (\d+) שחקנים$/, 'Up to $1 players'],
);

DATE_TOKENS.push(
  ["בדצמ'", 'Dec'], ["בינו'", 'Jan'], ["בפבר'", 'Feb'], ["באפר'", 'Apr'], ["באוג'", 'Aug'],
  ["בספט'", 'Sep'], ["באוק'", 'Oct'], ["בנוב'", 'Nov'],
  ["דצמ'", 'Dec'], ["ינו'", 'Jan'], ["פבר'", 'Feb'], ["אפר'", 'Apr'], ["אוג'", 'Aug'],
  ["ספט'", 'Sep'], ["אוק'", 'Oct'], ["נוב'", 'Nov'],
  ['שישי-שני', 'Fri-Mon'], ['שישי-ראשון', 'Fri-Sun'], ['חמישי-ראשון', 'Thu-Sun'],
  ['סופ"ש', 'weekend'],
);

Object.assign(DICT, {
  'לעיצוב הקלאסי': 'Classic design',
  'לעיצוב החדש': 'New design',
  'עיצוב קלאסי': 'Classic design',
  'עיצוב חדש': 'New design',
  'חזרה לעיצוב החדש ✨': 'Back to the new design ✨',
});

Object.assign(DICT, { 'לעיצוב החדש ✨': 'New design ✨' });

// ===== Iteration 46 gap fixes =====
Object.assign(DICT, {
  'תחרויות הדחה': 'Elimination Tournaments',
  'תחרויות קבוצות': 'Team Tournaments',
  'קיר ההישגים': 'Wall of Achievements',
  'מוכנים לשחק?': 'Ready to play?',
  'הצטרפו אלינו והתחילו לשחק בתחרויות הטניס המרגשות ביותר בישראל': 'Join us and start playing in the most exciting tennis tournaments in Israel',
  'הירשם בחינם': 'Sign up for free',
  'רמות': 'Levels',
  'נוער': 'Youth',
  '💬 שלח הודעה': '💬 Send message',
  '📞 התקשרו אלינו': '📞 Call us',
  // Training camps - full coverage
  'הסעות לצרכי הקבוצה': 'Group transportation',
  'מאמן מלווה מישראל': 'Accompanying coach from Israel',
  '2 אטרקציות': '2 attractions',
  'חצי פנסיון': 'Half board',
  'כולל ארוחת ערב במסעדה של נובאק ג׳וקוביץ׳ בעיר': "Including dinner at Novak Djokovic's restaurant in the city",
  '1,500€ לאדם בחדר יחיד | 1,300€  לאדם בחדר זוגי': '€1,500 per person in a single room | €1,300 per person in a double room',
  'סיור במוזיאון הטניס הסרבי': 'Tour of the Serbian tennis museum',
  'ביקור במועדון הילדות של ג׳וקוביץ׳': "Visit to Djokovic's childhood club",
  'שייט בנהר הדנובה': 'Danube river cruise',
  'סיור בעיר העתיקה של בלגרד': "Tour of Belgrade's old town",
  'ערב בשכונת Skadarlija התוססת': 'Evening in the lively Skadarlija quarter',
  'ביקור במבצר Kalemegdan': 'Visit to Kalemegdan fortress',
  'הרשמה למחנה': 'Register for the camp',
  'יוקרה, מצוינות וחדשנות - מתקני הטניס המתקדמים בעולם': "Luxury, excellence and innovation — the world's most advanced tennis facilities",
  'מתקני טניס ברמה של טורנירי ATP': 'ATP-tournament-grade tennis facilities',
  'מלונות 5 כוכבים יוקרתיים': 'Luxurious 5-star hotels',
  'אקלים חם ויבש (מתאים לחורף)': 'Warm, dry climate (great for winter)',
  'חוויית יוקרה ושירות ברמה עולמית': 'A luxury experience with world-class service',
  'קרבה לישראל (טיסה קצרה)': 'Close to Israel (short flight)',
  '4 לילות - 5 ימים (סופ״ש)': '4 nights - 5 days (weekend)',
  'תאריכים יפורסמו בקרוב': 'Dates to be announced soon',
  '8 שעות טניס עם מאמנים בכירים': '8 hours of tennis with senior coaches',
  'מחירים יפורסמו בקרוב': 'Prices to be announced soon',
  'עליה לבורג׳ ח׳ליפה - הבניין הגבוה בעולם': "Going up the Burj Khalifa — the world's tallest building",
  'קניות ב-Dubai Mall ו-Mall of Emirates': 'Shopping at Dubai Mall & Mall of the Emirates',
  'ספארי במדבר עם רכיבה על גמלים': 'Desert safari with camel rides',
  'שייט ביאכטה במרינה של דובאי': 'Yacht cruise in Dubai Marina',
  'ביקור באיי התמרים (Palm Jumeirah)': 'Visit to Palm Jumeirah',
  'פארק המים Wild Wadi': 'Wild Wadi water park',
  'ערב בשוק הזהב והתבלינים': 'Evening at the Gold & Spice Souk',
  'פנינת הבלקן - שילוב של טניס, טבע עוצר נשימה וים תיכוני': 'The pearl of the Balkans — tennis, breathtaking nature and the Mediterranean',
  'שילוב של טניס וחופשה בים התיכון': 'Tennis combined with a Mediterranean vacation',
  'מזג אויר מושלם באביב וסתיו': 'Perfect weather in spring and autumn',
  'נופים עוצרי נשימה - הרים וים': 'Breathtaking scenery — mountains and sea',
  'מחירים אטרקטיביים': 'Attractive prices',
  'סביבה רגועה ונעימה לאימונים': 'A calm, pleasant training environment',
  'סיור בעיר העתיקה של קוטור (אתר UNESCO)': 'Tour of Kotor old town (UNESCO site)',
  'שייט במפרץ קוטור המרהיב': 'Cruise in the stunning Bay of Kotor',
  'טיול להרי Durmitor הלאומיים': 'Trip to Durmitor national mountains',
  'ביקור באי Sveti Stefan האגדי': 'Visit to the legendary Sveti Stefan islet',
  'שחייה בחופי Budva המפורסמים': "Swimming at Budva's famous beaches",
  'סיור במערות Lipa Cave': 'Tour of Lipa Cave',
  'ערב בעיר העתיקה עם מסעדות מקומיות': 'Evening in the old town with local restaurants',
  'צרו קשר ונשמח לעזור בכל שאלה': 'Contact us — happy to help with any question',
  // Points system tips
  'טיפים לצבירת נקודות': 'Tips for earning points',
  'מערכת הניקוד מבוססת על': 'The points system is based on',
  'בלבד. אם הגעת לחצי גמר - תקבל את נקודות חצי הגמר בלבד (לא צבירה של כל השלבים הקודמים).': 'only. If you reached the semifinal — you get the semifinal points only (not a sum of all previous stages).',
  'משחק בהרבה תחרויות יומיות והשתדל להגיע לרבע גמר לפחות - 10 תחרויות ברבע גמר =': 'Play many daily tournaments and aim for at least the quarterfinals — 10 tournaments at QF level =',
  'התמקדות בתחרויות נוקאאוט והגעה למקומות גבוהים - מקום 1 בנוקאאוט =': 'Focus on knockout tournaments and finishing high — 1st place in a knockout =',
  'שווה כמו': 'is worth',
  'בתחרויות יומיות.': 'in daily tournaments.',
  '2.3 זכיות': '2.3 wins',
  'זכה בתחרות = 150 נקודות בלבד': 'Won the tournament = 150 points only',
  'הפסיד בחצי גמר = 65 נקודות בלבד': 'Lost in the semifinal = 65 points only',
  'זכה בתחרות = 350 נקודות בלבד': 'Won the tournament = 350 points only',
  '• זכייה יומית (150) = רבע גמר נוקאאוט (80) + חצי גמר יומית (65)': '• Daily win (150) = knockout QF (80) + daily SF (65)',
  '• זכייה נוקאאוט (350) = 2.3 זכיות יומיות': '• Knockout win (350) = 2.3 daily wins',
  '• מקום 3 נוקאאוט (170) ≈ זכייה יומית + רבע גמר יומית': '• Knockout 3rd place (170) ≈ daily win + daily QF',
  'השלב הסופי': 'the final stage',
});

REGEX_RULES.push(
  [/^© (\d{4}) Tennis Pro Israel\. כל הזכויות שמורות\.$/, '© $1 Tennis Pro Israel. All rights reserved.'],
  [/^מתוך (\d+) המשתתפים$/, 'Of the $1 participants'],
  [/^(\d+) נקודות!$/, '$1 points!'],
  [/^(\d+) נקודות בלבד$/, '$1 points only'],
);

Object.assign(DICT, {
  'חוויה בלתי נשכחת המשלבת אימוני טניס מקצועיים עם מאמנים מקומיים בעלי ניסיון בינלאומי, בליווי מאמן ישראלי לאורך כל המחנה. ימי האימון משלבים עבודה על הקורט, ניתוחי משחק, כושר גופני וטיולים מודרכים - בקבוצות קטנות לפי רמה, באווירה משפחתית ומקצועית.': 'An unforgettable experience combining professional tennis training with internationally experienced local coaches, accompanied by an Israeli coach throughout the camp. Training days combine on-court work, match analysis, fitness and guided tours — in small groups by level, in a professional, family-like atmosphere.',
  'בלגרד היא בירת סרביה, מדינה עם מסורת טניס עשירה שהעניקה לעולם אלופים כמו נובאק ג׳וקוביץ׳. העיר מציעה שילוב מושלם של היסטוריה, תרבות ספורט, וחיי לילה תוססים. האקלים הים-תיכוני והמתקנים המקצועיים הופכים אותה ליעד מושלם למחנה אימונים.': 'Belgrade is the capital of Serbia, a country with a rich tennis tradition that gave the world champions like Novak Djokovic. The city offers a perfect blend of history, sports culture and vibrant nightlife. The Mediterranean climate and professional facilities make it a perfect training-camp destination.',
  'דובאי היא בירת היוקרה והספורט של המזרח התיכון. העיר מארחת את טורניר דובאי לטניס (ATP 500) ומציעה מתקנים מהמתקדמים בעולם. האקלים החם (אך יבש), המלונות היוקרתיים, ורמת השירות הגבוהה הופכים את דובאי ליעד פרימיום למחנות אימונים.': "Dubai is the Middle East's capital of luxury and sport. The city hosts the Dubai Tennis Championships (ATP 500) and offers some of the world's most advanced facilities. The hot (but dry) climate, luxurious hotels and top-tier service make Dubai a premium training-camp destination.",
  'מונטנגרו (הר השחור) היא פנינה נסתרת בחוף הים התיכון. המדינה מציעה שילוב ייחודי של טניס ברמה גבוהה, חופים מדהימים, והרים מרהיבים. האקלים הים-תיכוני, המתקנים המצוינים, והאווירה הרגועה הופכים אותה ליעד מושלם למחנה אימונים משולב עם חופשה.': 'Montenegro (the "Black Mountain") is a hidden gem on the Mediterranean coast. The country offers a unique mix of high-level tennis, stunning beaches and magnificent mountains. The Mediterranean climate, excellent facilities and relaxed atmosphere make it a perfect destination for a training camp combined with a vacation.',
});

Object.assign(DICT, {
  'מחק שיחה': 'Delete chat',
  'מחק הודעה': 'Delete message',
  'השיחה נמחקה 🗑️': 'Chat deleted 🗑️',
  'שגיאה במחיקת השיחה': 'Error deleting chat',
  'ההודעה נמחקה': 'Message deleted',
});

Object.assign(DICT, {
  'למחוק את ההודעה?': 'Delete this message?',
  'מחק אצלי בלבד': 'Delete for me only',
  'מחק אצל כולם': 'Delete for everyone',
  'ההודעה נמחקה אצלך': 'Message deleted for you',
  'ההודעה נמחקה אצל כולם': 'Message deleted for everyone',
});

Object.assign(DICT, { 'ווצאפ': 'WhatsApp', 'שלח הודעה': 'Send message' });

Object.assign(DICT, {
  'לוח ציוד': 'Gear Board',
  'לוח ציוד יד שנייה/חדש': 'Second-hand / New Gear Board',
  'קונים ומוכרים בקהילה': 'Buy & sell in the community',
  'ציוד טניס יד שנייה וחדש — פרסם מודעה או צור קשר עם המוכר': 'Second-hand and new tennis gear — post an ad or contact the seller',
  'פרסם מודעה': 'Post an ad',
  'התחבר כדי לפרסם מודעה': 'Log in to post an ad',
  'מחבטים': 'Rackets',
  'נעליים': 'Shoes',
  'תיקים': 'Bags',
  'מיתרים': 'Strings',
  'גידים למחבט': 'Racket strings',
  'ביגוד': 'Apparel',
  'אחר': 'Other',
  'הכל': 'All',
  'חדש': 'New',
  'כמו חדש': 'Like new',
  'משומש': 'Used',
  'נמכר ✔': 'Sold ✔',
  'חינם': 'Free',
  'חינם 🎁': 'Free 🎁',
  'נמכרו לאחרונה': 'Recently sold',
  'אין מודעות בקטגוריה זו — היה הראשון לפרסם!': 'No ads in this category — be the first to post!',
  'מודעה חדשה': 'New ad',
  'פרסם ציוד למכירה — חדש או יד שנייה': 'Post gear for sale — new or second-hand',
  'שם המוצר *': 'Product name *',
  'קטגוריה *': 'Category *',
  'מצב *': 'Condition *',
  'מחיר (₪) *': 'Price (₪) *',
  'תמונות (עד 5)': 'Photos (up to 5)',
  'תיאור': 'Description',
  'אזור מסירה': 'Pickup area',
  'טלפון לווצאפ (לא חובה)': 'WhatsApp phone (optional)',
  'אם תוסיף - יופיע כפתור ווצאפ ירוק על המודעה': 'If added — a green WhatsApp button will appear on the ad',
  'מפרסם...': 'Posting...',
  'פרסם מודעה 🛒': 'Post ad 🛒',
  'סמן כנמכר': 'Mark as sold',
  'החזר לפעיל': 'Reactivate',
  'התחבר כדי ליצור קשר': 'Log in to contact',
  'המודעה פורסמה! 🛒': 'Ad posted! 🛒',
  'המודעה סומנה כנמכר 🎉': 'Ad marked as sold 🎉',
  'המודעה חזרה להיות פעילה': 'Ad is active again',
  'עד 5 תמונות למודעה': 'Up to 5 photos per ad',
  'למחוק את המודעה?': 'Delete this ad?',
  'המודעה נמחקה': 'Ad deleted',
  'בחר': 'Select',
});

Object.assign(DICT, {
  'קנו ומכרו ציוד טניס בקהילה — מחבטים, נעליים, גידים ועוד': 'Buy & sell tennis gear in the community — rackets, shoes, strings and more',
  'לכל המודעות': 'View all ads',
  'עדיין אין מודעות — היו הראשונים למכור ציוד!': 'No ads yet — be the first to sell gear!',
  'פרסמו מודעה ראשונה': 'Post the first ad',
});

Object.assign(DICT, {
  'התראות ציוד': 'Gear alerts',
  'התראות ציוד חדש': 'New gear alerts',
  'בחר קטגוריות — נודיע לך ברגע שעולה מודעה מתאימה': 'Pick categories — we will notify you when a matching ad is posted',
  'שמור התראות 🔔': 'Save alerts 🔔',
  'שומר...': 'Saving...',
  'ההתראות נשמרו! 🔔': 'Alerts saved! 🔔',
  'ההתראות בוטלו': 'Alerts turned off',
  'הצטרפו לקהילה!': 'Join the community!',
  'כדי להירשם לתחרויות, לשלוח הודעות, למכור ולקנות ציוד — חייבים לפתוח משתמש. ההרשמה חינם ולוקחת פחות מדקה!': 'To register for tournaments, send messages and buy or sell gear — you must create an account. Signing up is free and takes less than a minute!',
  'הירשמו עכשיו בחינם': 'Sign up now for free',
  'כבר יש לי משתמש — התחברות': 'I already have an account — log in',
  'אולי מאוחר יותר': 'Maybe later',
  'החיבור שלך פג': 'Your session expired',
  'התנתקת מהאתר. יש להתחבר מחדש כדי להמשיך להשתמש בכל האפשרויות.': 'You were logged out. Please log in again to keep using all features.',
  'התחבר מחדש': 'Log in again',
  'המשך כאורח': 'Continue as guest',
});

Object.assign(DICT, {
  'צפיות': 'views',
  'אנשים צפו במודעה שלך 👀': 'people viewed your ad 👀',
});

Object.assign(DICT, {
  'מבוקש': 'Hot',
  'ביקורות על המוכר': 'Seller reviews',
  'עדיין אין ביקורות על המוכר': 'No reviews for this seller yet',
  'דרג את המוכר': 'Rate the seller',
  'איך הייתה החוויה שלך עם המוכר?': 'How was your experience with the seller?',
  'אמין': 'Reliable',
  'הוגן': 'Fair',
  'זמין': 'Responsive',
  'תקשורת מעולה': 'Great communication',
  'מוצר כמתואר': 'Item as described',
  'מומלץ': 'Recommended',
  'מילה טובה על המוכר (לא חובה)': 'A kind word about the seller (optional)',
  'שמור ביקורת ⭐': 'Save review ⭐',
  'הביקורת נשמרה! ⭐': 'Review saved! ⭐',
  'יש לבחור לפחות תכונה אחת': 'Pick at least one trait',
  'אי אפשר לדרג את עצמך': 'You cannot rate yourself',
  'הביקורת נמחקה': 'Review deleted',
});
